import image1 from "../../../Assets/Carocel-image/charcoal.jpg";
import image2 from "../../../Assets/Carocel-image/cocoa.jpg";
import image3 from "../../../Assets/cashew/Cashew kernel.jpeg";
import image4 from "../../../Assets/Carocel-image/seasame.jpg";
import image5 from "../../../Assets/Carocel-image/Shea-butter.jpg";
import image6 from "../../../Assets/Carocel-image/connect.jpg";
const data = [
  {
    id: 0,
    image:
      "https://images.pexels.com/photos/30517082/pexels-photo-30517082/free-photo-of-container-ship-docked-at-hamburg-port.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    textBig:
      "Welcome to Finbarn Wepo Agro Allied Commodities and Logistics solutions",
    textSmall:
      "We are a company that is committed to providing the best quality products and services to our customers. We are always looking for ways to improve and grow, and we would love for you to join us on this journey.",
  },
  {
    id: 1,
    image: image1,
    textBig: "Providing agro Allied commodities",
    textSmall:
      "As a fast-growing company, we want to ensure trust in our customers. Hence, we are registered with the Nigerian Export Promotion Council.",
  },
  {
    id: 2,
    image: image2,
    textBig:
      "Ensuring standards of quality and quantity with Our Agricultural Commodities",
    textSmall:
      "Our materials for exports in Nigeria are FoodStuffs and agricultural commodities of the finest quality.",
  },
  {
    id: 3,
    image: image3,
    textBig: "Trading Globally for nearly a decade",
    textSmall:
      "Since our inception in 2018, Finbarn has been an up-and-coming commodities and trading company based out of Nigeria.",
  },
  {
    id: 4,
    image: image4,
    textBig: "Quality Agro Allied Products",
    textSmall:
      "Quality means doing it right when no one is looking. Our Product is always the Best among the rest",
  },
  {
    id: 5,
    image: image5,
    textBig: "Grade Perfection",
    textSmall:
      "Perfection is achieved, not when there is nothing more to add, but when there is nothing left to take away.Our Product are always Top Notch",
  },
  {
    id: 6,
    image: image6,
    textBig: "We Connect Countries",
    textSmall: " We Trade Our Agro Commodities around the world....",
  },
];
export default data;

export const products = [
  {
    name: "Dried Fish",
    description: "High-quality, sun-dried Nigerian fish, ideal for export.",
    image:
      "https://images.pexels.com/photos/30112814/pexels-photo-30112814/free-photo-of-vibrant-display-of-dried-seafood-in-digha-market.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    name: "Garri",
    description: "Cassava flakes, a staple food in many Nigerian homes.",
    image:
      "https://mile12market.com/wp-content/uploads/2014/12/mile12_market_online_white_garri-Copy.jpg",
  },
  {
    name: "Brown Beans",
    description: "Protein-rich Nigerian brown beans, freshly packed.",
    image:
      "https://dailytrust.com/wp-content/uploads/2024/06/honey-beans.jpg.webp",
  },
  {
    name: "Ankara Fabric",
    description: "Vibrant African prints perfect for fashion and design.",
    image:
      "https://www.allthingsankara.com/wp-content/uploads/2014/09/balogun_market_ankara_fabric.jpg",
  },
  {
    name: "Palm Oil",
    description: "Rich and natural Nigerian red palm oil.",
    image: "https://sc04.alicdn.com/kf/A06e2b895cba9436abae62a4c7bf4192fo.jpeg",
  },
  {
    name: "Rice",
    description: "High-quality Nigerian rice, perfect for export.",
    image:
      "https://24hoursmarket.com/wp-content/uploads/2020/03/IMG_20200315_121254-1-scaled.jpg",
  },
  {
    name: "Groundnut",
    description: "Crunchy, roasted Nigerian peanuts in bulk.",
    image:
      "https://i0.wp.com/ounjealadun.com/wp-content/uploads/2015/03/20200619_155233_wm-1.jpg?resize=1108%2C1477&ssl=1",
  },
  {
    name: "Yam Flour (Elubo)",
    description: "Powdered yam for preparing amala, a Yoruba delicacy.",
    image:
      "https://airahsolutionsltd.com/wp-content/uploads/2022/03/elubo-1.jpg",
  },
  {
    name: "Locust Beans (Iru)",
    description: "Fermented beans for enhancing traditional soups.",
    image:
      "https://flourishafricanmart.com/cdn/shop/products/Iru-Locus-bean-1_300x300.jpg?v=1581485815",
  },
  {
    name: "Snails",
    description: "Cleaned and packaged African giant snails.",
    image:
      "https://cokodeal.com/images/sellers_deals/FB_IMG_1664366112973-1-1712437075.jpg",
  },
  {
    name: "Ogbono Seeds",
    description: "Wild mango seeds for making ogbono soup.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJdt_P9M5SCs8IHnMkN5qNDoQS0bGE3_OfMw&s",
  },
  {
    name: "Crayfish",
    description: "Sun-dried crayfish for flavor-rich Nigerian cooking.",
    image:
      "https://i.etsystatic.com/46327978/c/2142/2142/0/355/il/499c4c/5224578222/il_300x300.5224578222_78ka.jpg",
  },
  {
    name: "Dried Pepper",
    description: "Hot and spicy sun-dried Nigerian pepper.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmGqrZVqE135gENVsSiMUX4eFCq4b7R3coxQ&s",
  },
  {
    name: "Cassava",
    description: "Raw cassava tubers harvested fresh from the farm.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2iq_CaqDK5G6UUWgnolodSVUrNB4X4HcPQA&s",
  },

  {
    name: "Honey",
    description: "Natural Nigerian honey harvested from the wild.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQroHInGooDXxeQAAmF9PUY8RIrQIffw5e2vg&s",
  },
  {
    name: "Okra",
    description: "Fresh okra pods used in soups and stews.",
    image:
      "https://media.istockphoto.com/id/1053422448/photo/fresh-okra-at-vegetable-market.jpg?s=612x612&w=0&k=20&c=MTOcSbW6vmni4MqLYNMO-FHu8JMrOBZO5g_Q_izb6ws=",
  },

  {
    name: "Achi Powder",
    description: "Soup thickener used in Eastern Nigerian cuisine.",
    image:
      "https://i0.wp.com/orljaa.com/wp-content/uploads/2020/08/ACHI-POWDER-600x600-1.jpg",
  },
  {
    name: "Africa Native Men Wears",
    description: "Traditional African clothing for all occasions.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOAxTrG3-0US8_OhvmLQTe9TM_5uhna5TO8w&s",
  },
  {
    name: "Africa Native Women Wears",
    description: "Traditional African clothing for all occasions.",
    image: "https://m.media-amazon.com/images/I/71h-dspp0iL._AC_UY1000_.jpg",
  },
];
